import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Merchant } from '../../types/merchant';
import type { RootState } from '../../types';

export interface MerchantState {
  merchants: Merchant[];
  selectedMerchant: Merchant | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: MerchantState = {
  merchants: [],
  selectedMerchant: null,
  isLoading: false,
  error: null,
};

export const merchantSlice = createSlice({
  name: 'merchant',
  initialState,
  reducers: {
    setMerchants: (state, action: PayloadAction<Merchant[]>) => {
      state.merchants = action.payload;
      state.error = null;
    },
    setSelectedMerchant: (state, action: PayloadAction<Merchant | null>) => {
      state.selectedMerchant = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearMerchantState: () => initialState,
  },
});

export const {
  setMerchants,
  setSelectedMerchant,
  setLoading,
  setError,
  clearMerchantState,
} = merchantSlice.actions;

export const selectMerchants = (state: RootState) => state.merchant.merchants;
export const selectSelectedMerchant = (state: RootState) =>
  state.merchant.selectedMerchant;
export const selectIsMultiMerchantUser = (state: RootState) =>
  state.merchant.merchants.length > 1;
export const selectMerchantId = (state: RootState) =>
  state.merchant.selectedMerchant?.merchant_id ?? null;

export default merchantSlice.reducer;
